<template>
  <div class="dropdown-container">
    <DropdownPrime 
      v-model="selectedValue" 
      :options="options" 
      optionLabel="Glosa"
      optionValue="Id"    
      placeholder="Curso Casa" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-tooltip="tooltipOpts"
      @change="emitSelection"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import CursoService from '@/services/CursoService'; // Asegúrate de importar el servicio

export default {
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    tooltipOpts() {
      return {
        value: this.tooltip || '',
        position: 'bottom',
        disabled: !String(this.tooltip || '').trim(),
      };
    },
  },
  setup(props, { emit }) {
    const options = ref([]);
    function normCasa(v) {
      if (v === '' || v === undefined || v === null) return null;
      return v;
    }
    const selectedValue = ref(normCasa(props.modelValue));

    const fetchOptions = async () => {
      try {
        const response = await CursoService.getCasas(); // Llama al método getCursosCasa
        options.value = response.data; // Asegúrate de que la respuesta tenga la estructura correcta
      } catch (error) {
        console.error('Error al cargar opciones:', error);
      }
    };

    const emitSelection = () => {
      emit('update:modelValue', selectedValue.value);
    };

    watch(() => props.modelValue, (v) => {
      selectedValue.value = normCasa(v);
    });

    onMounted(() => {
      fetchOptions(); // Llama a la función para cargar las opciones al montar el componente
    });

    return {
      options,
      selectedValue,
      emitSelection,
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
}
</style>
